package org.zq.astrock_ai.ui.research.gushi.components

import org.zq.astrock_ai.util.formatDecimal

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import org.zq.astrock_ai.ui.research.gushi.StockColors
import org.zq.astrock_ai.ui.research.gushi.adaptiveDialogWidth
import org.zq.astrock_ai.ui.research.gushi.model.HoldingPosition
import org.zq.astrock_ai.ui.research.gushi.model.StockItem

@Composable
fun AddHoldingDialog(
    stock: StockItem,
    existing: HoldingPosition?,
    onDismiss: () -> Unit,
    onConfirm: (costPrice: Double, quantity: Int) -> Unit,
    onClear: (() -> Unit)? = null,
) {
    var costText by remember(existing) {
        mutableStateOf(existing?.costPrice?.let { formatDecimal(it) }.orEmpty())
    }
    var qtyText by remember(existing) {
        mutableStateOf(existing?.quantity?.takeIf { it > 0 }?.toString().orEmpty())
    }
    var error by remember { mutableStateOf<String?>(null) }

    val fieldColors = OutlinedTextFieldDefaults.colors(
        focusedTextColor = StockColors.TextPrimary,
        unfocusedTextColor = StockColors.TextPrimary,
        focusedBorderColor = StockColors.PrimaryBlue,
        unfocusedBorderColor = StockColors.Border,
        cursorColor = StockColors.PrimaryBlue,
        focusedLabelColor = StockColors.TextSecondary,
        unfocusedLabelColor = StockColors.TextSecondary,
        focusedContainerColor = Color.White,
        unfocusedContainerColor = Color.White,
    )
    val shape = RoundedCornerShape(14.dp)

    Dialog(onDismissRequest = onDismiss) {
        Column(
            modifier = Modifier
                .adaptiveDialogWidth(360.dp)
                .background(Color.White, shape)
                .border(BorderStroke(1.dp, StockColors.Border), shape)
                .padding(20.dp),
        ) {
            Text(
                if (existing != null) "编辑持仓" else "添加持仓",
                color = StockColors.TextPrimary,
                fontWeight = FontWeight.Bold,
                fontSize = 18.sp,
            )
            Spacer(Modifier.height(6.dp))
            Text(
                "${stock.name}（${stock.code}）· 现价 ${stock.price}",
                color = StockColors.TextSecondary,
                fontSize = 13.sp,
            )

            Spacer(Modifier.height(16.dp))

            OutlinedTextField(
                value = costText,
                onValueChange = {
                    costText = it.filter { ch -> ch.isDigit() || ch == '.' }
                    error = null
                },
                label = { Text("成本价（元）") },
                singleLine = true,
                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
                colors = fieldColors,
                modifier = Modifier.fillMaxWidth(),
            )

            Spacer(Modifier.height(10.dp))

            OutlinedTextField(
                value = qtyText,
                onValueChange = {
                    qtyText = it.filter { ch -> ch.isDigit() }
                    error = null
                },
                label = { Text("持仓数量（股）") },
                singleLine = true,
                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                colors = fieldColors,
                modifier = Modifier.fillMaxWidth(),
            )

            if (error != null) {
                Spacer(Modifier.height(8.dp))
                Text(error!!, color = StockColors.UpRed, fontSize = 12.sp)
            }

            Spacer(Modifier.height(18.dp))

            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
            ) {
                if (existing != null && onClear != null) {
                    OutlinedButton(
                        onClick = onClear,
                        border = BorderStroke(1.dp, StockColors.Border),
                        colors = ButtonDefaults.outlinedButtonColors(
                            contentColor = StockColors.TextSecondary,
                        ),
                    ) {
                        Text("清除", color = StockColors.TextSecondary, fontSize = 13.sp)
                    }
                }
                Spacer(Modifier.weight(1f))
                OutlinedButton(
                    onClick = onDismiss,
                    border = BorderStroke(1.dp, StockColors.Border),
                    colors = ButtonDefaults.outlinedButtonColors(
                        contentColor = StockColors.TextPrimary,
                    ),
                ) {
                    Text("取消", color = StockColors.TextPrimary, fontSize = 13.sp)
                }
                Button(
                    onClick = {
                        val cost = costText.toDoubleOrNull()
                        val qty = qtyText.toIntOrNull()
                        when {
                            cost == null || cost <= 0 -> error = "请输入有效成本价"
                            qty == null || qty <= 0 -> error = "请输入有效持仓数量"
                            else -> onConfirm(cost, qty)
                        }
                    },
                    colors = ButtonDefaults.buttonColors(
                        containerColor = StockColors.UpRed,
                        contentColor = Color.White,
                    ),
                ) {
                    Text("保存", color = Color.White, fontSize = 13.sp)
                }
            }
        }
    }
}
